/**
 * Creates a helper function to find which sprint a task belongs to.
 * 
 * @param {Array} tasks - Current sprint's tasks
 * @param {Object} localSprint - Current sprint object
 * @param {Array} allSprints - All sprints in the app
 * @returns {Function} findSprintForTask(taskId) => { sprint, isCurrentSprint }
 */
export const createFindSprintForTask = (tasks, localSprint, allSprints) => (taskId) => {
  // Check current sprint first
  if (tasks.some(t => t.id === taskId)) {
    return { sprint: localSprint, isCurrentSprint: true };
  }
  // Check all other sprints
  for (const s of allSprints) {
    if (s.tasks?.some(t => t.id === taskId)) {
      return { sprint: s, isCurrentSprint: false };
    }
  }
  return { sprint: null, isCurrentSprint: false };
};
